import {addClass, removeClass} from "../_vars";

export const reviewReadMore = () => {
    const reviewItems = document.querySelectorAll(".recall-item");
    reviewItems.forEach((item) => {
        const btn = item.querySelector(".recall-item__more");
        const hiddenText = item.querySelector(".--hidden");
        if (btn) {
            btn.addEventListener("click", () => {
                btn.remove();
                removeClass(hiddenText, "--hidden");
            });
        }
    });
};

const openModalFormButtons = document.querySelectorAll('[data-target="openModal"]');
openModalFormButtons.forEach(function (button) {
    let modalTarget = button.getAttribute('data-modal');
    let modal = document.querySelector(`[data-target="modal"][data-modal="${modalTarget}"]`);
    if (modal) {
        let modalForm = modal.querySelector('form')
        let modalClose = modal.querySelector('.recall-form__close')

        button.addEventListener('click', function () {
            addClass(modal, "show");
        })
        modal.addEventListener("click", (e) => {
            if (e.target.classList.contains("recall-modal")) {
                removeClass(modal, "show");
            }
        });
        modalClose.addEventListener("click", (e) => {
            removeClass(modal, "show");
        });
        modalForm.addEventListener('submit', function (e) {
            e.preventDefault();
            removeClass(modal, "show");
        })
    }

});


const reviewModal = document.querySelector(".recall-modal");
const recallForm = document.querySelector(".recall-form");
const recallThanks = document.querySelector(".recall-thanks");

export const addReview = () => {
    const reviewAddBtn = document.querySelector(".recall-add");
    const reviewModalClose = document.querySelector(".recall-form__close");
    if (reviewAddBtn) {
        reviewAddBtn.addEventListener("click", () => {
            addClass(reviewModal, "show");
        });
        reviewModal.addEventListener("click", (e) => {
            if (e.target.classList.contains("recall-modal")) {
                removeClass(reviewModal, "show");
                removeClass(recallForm, "hide");
                removeClass(recallThanks, "show");
            }
        });
        reviewModalClose.addEventListener("click", (e) => {
            removeClass(reviewModal, "show");
        });
    }
};

export const submitRecallForm = () => {
    const recallThanksClose = document.querySelector(".recall-thanks__close");
    if (recallForm) {
        recallForm.addEventListener("submit", (e) => {
            e.preventDefault();
            setTimeout(() => {
                addClass(recallForm, "hide");
                addClass(recallThanks, "show");
            }, 500);
        });
        recallThanksClose.addEventListener("click", (e) => {
            removeClass(reviewModal, "show");
            removeClass(recallThanks, "show");
            removeClass(recallForm, "hide");
        });
    }
};

const loadMore = document.querySelector('button[data-load_reviews]');
if (loadMore) {
    const reviewsBlock = document.querySelector('.recall__blocks');

    loadMore.addEventListener('click', function (e) {
        e.preventDefault();

        let pageLoad = parseInt(loadMore.getAttribute('data-load_reviews'));

        fetch(`/reviews/` + pageLoad, {
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            },
        }).then((response) => response.text())
            .then((html) => {
                let parser = new DOMParser();
                let doc = parser.parseFromString(html, 'text/html');

                let elems = doc.querySelectorAll('div.recall-item');
                if (elems.length) {
                    elems.forEach(function (elem) {
                        reviewsBlock.appendChild(elem);
                    })
                }
                pageLoad = pageLoad + 1;
                let totalPage = parseInt(loadMore.getAttribute('data-total_pages'));
                if (totalPage < pageLoad)
                    loadMore.style.display = "none";
                else
                    loadMore.setAttribute('data-load_reviews', pageLoad);

            });


    });
}
